import { type PostFormFormParticipationByFormIdData } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchBackofficeForm, type FetchBackOfficeFormParams } from '../api/bo-form';

export const backofficeFormKeys = {
	all: ['backofficeForm'] as const
};

export const useBackofficeFormQueries = (
	params: FetchBackOfficeFormParams,
	options?: Omit<UseQueryOptions<PostFormFormParticipationByFormIdData, unknown>, 'queryFn' | 'queryKey'>
) => {
	const { formId } = params;

	const getBOForm = () => {
		return fetchBackofficeForm(params);
	};

	const { data, error, isFetched, isFetching, isLoading, refetch } = useQuery({
		queryFn: getBOForm,
		queryKey: [backofficeFormKeys.all, formId],
		...options
	});

	return { data, error, isFetched, isFetching, isLoading, refetch };
};
